import React from "react";

export default function ExperienceHeroSection({ heroImage, galleryImages }) {
  return (
    <div className="w-full relative">
      {/* Full-width hero image */}
      <div className="w-full h-[420px] overflow-hidden">
        <img
          src={heroImage}
          alt="Experience"
          className="w-full h-full object-cover object-center"
          loading="lazy"
        />
      </div>

      {/* Floating gallery container (Figma style) */}
      <div className="absolute left-1/2 bottom-[-1px] -translate-x-1/2 w-[85%] rounded-2xl  flex justify-center items-center gap-5 px-6 py-4">
        <div className="flex gap-4">
          {galleryImages.map((img, i) => (
            <div
              key={i}
              className="w-[200px] h-[150px] rounded-lg overflow-hidden"
            >
              <img
                src={img}
                alt=""
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Push content below */}
      <div className="h-[70px]"></div>
    </div>
  );
}
